export class ErrorTemplateBuilder {
  static getCatchText(methodName: string, ex: any) {
    return ex.message &&
      ex.message != "" &&
      !ex.message.includes("gorelo-method")
      ? `gorelo-method: ${methodName} , errorMessage: ${ex.message} , stack:${ex.stack}`
      : ` gorelo-method: ${methodName} -> ${ex.message}`;
  }
}
